import RegisterBetaAccessForm from "./RegisterBetaAccessForm";

export default RegisterBetaAccessForm;
